import { RewindIcon } from './RewindIcon';

/**
 * author: Google
 * id 28BCDF41-AA93-4C25-B87A-95A3F5DD8805
 * name rewind
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rewind.svg
 * tags
 */
export const FastRewindIcon = RewindIcon;
export default FastRewindIcon